import { CalendarDays } from "lucide-react";
import type { InputHTMLAttributes } from "react";

export function DateInput(props: Omit<InputHTMLAttributes<HTMLInputElement>, "type">) {
  return (
    <div className="date-input-shell">
      <input {...props} type="date" />
      <CalendarDays size={18} aria-hidden="true" />
    </div>
  );
}
